import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
  menuItem:{
    color: theme.palette.primary.main,
    fontWeight:300,
    size:18,
    lineHeight:'21.09px',
    '&:hover':{
      backgroundColor: theme.palette.blue.lightest,
    },
    '&.Mui-selected':{
      backgroundColor: theme.palette.blue.lightest,
    },
    '&.Mui-selected:hover':{
      backgroundColor: theme.palette.blue.lightest,
    }
  }
}));
